import {useCallback} from 'react';

import {useAccountEntityTypes, useAccountStatuses, useCountries} from 'src/hooks/dictionaries';

import {COLUMNS} from '../constants';

import type {AccountSearchResult} from 'src/openapi/admin/models/AccountSearchResult';

export const useGetColumnValue = () => {
    const {getCountryByCode} = useCountries();
    const {getAccountStatusByCode} = useAccountStatuses();
    const {getAccountEntityTypeByCode} = useAccountEntityTypes();

    const getColumnValue = useCallback((columnId: string, account: AccountSearchResult) => {
        switch (columnId) {
            case COLUMNS.ACCOUNT_NAME:
            case COLUMNS.ACCOUNT_SEARCH_ID:
            case COLUMNS.PARENT_ACCOUNT_NAME:
                return account[columnId as keyof AccountSearchResult] || '';
            case COLUMNS.ACCOUNT_STATUS:
                return getAccountStatusByCode(account.accountStatus)?.description || '';
            case COLUMNS.ENTITY_TYPE:
                return getAccountEntityTypeByCode(account.entityType)?.description || '';
            case COLUMNS.ACCOUNT_COUNTRY:
                return getCountryByCode(account.country)?.description || '';
            case COLUMNS.IS_ACCOUNT_DELETED:
                return account.isDeleted ? 'Yes' : 'No';
            case COLUMNS.SSO_ENABLED:
                if (account.ssoEnabled === undefined) {
                    return '';
                }
                return account.ssoEnabled ? 'Yes' : 'No';
            case COLUMNS.SSO_MANDATORY:
                if (account.ssoMandatory === undefined) {
                    return '';
                }
                return account.ssoMandatory ? 'Yes' : 'No';
            default:
                return '';
        }
    }, [getCountryByCode, getAccountStatusByCode, getAccountEntityTypeByCode]);

    return {getColumnValue};
};
